import React, { useMemo, useState, useContext } from 'react';
import ModuleContext from 'CMFW/context/ModuleContext';
import { useForceRender } from 'hooks/useForceRender';
import { TranslationBankModel } from 'models/TranslationBankModel';
import { TranslationBankItemsModel } from 'models/TranslationBankItemsModel';
import { Split } from 'components/Split';
import { ContainerLeft, EditorRow } from 'components/common/styles';
import BankItemsList from '../../components/TranslationBank/BankItemsList';
import CopyItemModal from '../../components/TranslationBank/CopyItemModal';
import BankItemEditor from './BankItemEditor';
import TextInput from '../../../../CMFW/input/TextInput';
import SaveButton from '../../../../CMFW/button/SaveButton';

const BankItemsPanel: React.FC = () => {
  const forceRender = useForceRender();
  const bankModel = useContext(ModuleContext) as TranslationBankModel;
  const [editItemId, setEditItemId] = useState(0);
  const [copyItemModalOpen, setCopyItemModalOpen] = useState(false);

  // Always create items model based on bankModel from context
  const itemsModel = useMemo(() => {
    const model = new TranslationBankItemsModel({
      render: forceRender,
      bankId: bankModel.itemId || 0,
      bankModel: bankModel,
    });

    // Conditionally load grid data
    if (bankModel.itemId && bankModel.itemId !== bankModel.NEW_CREATE_ID) {
      model.getGrid();
    }

    return model;
  }, [bankModel.itemId, bankModel, forceRender]);

  return (
    <ModuleContext.Provider value={itemsModel}>
      <Split widthLeft={450}>
        <ContainerLeft>
          <ModuleContext.Provider value={bankModel}>
            <EditorRow>
              <TextInput keyName="name" label="Name" />
              <SaveButton />
            </EditorRow>
          </ModuleContext.Provider>
          <BankItemsList
            itemsModel={itemsModel}
            bankModel={bankModel}
            onSelectItem={setEditItemId}
            onCopyClick={() => setCopyItemModalOpen(true)}
            agentType={bankModel.itemUpdated?.agentType}
          />
        </ContainerLeft>

        <BankItemEditor itemId={editItemId} key={editItemId} />
      </Split>

      {copyItemModalOpen && <CopyItemModal onClose={() => setCopyItemModalOpen(false)} itemsModel={itemsModel} />}
    </ModuleContext.Provider>
  );
};

export default BankItemsPanel;
